import clsx from 'clsx'
import Image from 'next/image'

import FergalCrotty from 'web/assets/fergal-crotty.png'
import UpDigital from 'web/assets/up-digital.png'

export function Testimonials() {
  return (
    <div
      className={clsx(
        'flex px-[80px] py-[140px] flex-col gap-[40px]',
        'max-[768px]:px[20px] max-[768px]:pt-[2.5rem] max-[768px]:pb-[5rem] max-[768px]:px-[20px]'
      )}
    >
      <div
        className={clsx(
          'w-auto max-w-[1280px] flex mx-auto gap-[8px] justify-center items-start',
          'max-[768px]:w-[68vw]'
        )}
      >
        <h3
          className={clsx(
            'text-center text-[52px] tracking-[-2px] mb-0 font-[700] leading-[110%]',
            'max-[768px]:text-[7.8vw]'
          )}
        >
          See what they say about Mapstack
        </h3>
      </div>

      <div className='w-full max-w-[1280px] mx-auto'>
        <div className='flex items-center h-auto max-w-[976px] mx-auto'>
          <div
            className={clsx(
              'px-[88px] py-[64px] bg-brand-03 shadow-2xl rounded-[24px] max-w-none h-[627px]',
              'max-[768px]:w-full max-[768px]:h-auto max-[768px]:py-[40px] max-[768px]:px-[24px]'
            )}
          >
            <div className='pb-[24px]'>
              <h2
                className={clsx(
                  'text-center mb-[24px] px-[64px] text-[36px] font-[700] leading-[110%] text-white',
                  'max-[768px]:text-[24px]'
                )}
              >
                “It easily produces stunning maps with minimum effort”
              </h2>
              <p
                className={clsx(
                  'text-center text-[19px] font-[400] leading-[130%] text-white',
                  'max-[768px]:text-[16px]'
                )}
              >
                Mapstack revolutionized our PPC targeting. By visualizing
                customer locations, improved our ad targeting, refined ad spend,
                and saw immediate campaign improvements.
              </p>
            </div>
            <div className='flex w-full justify-start flex-col items-center'>
              <div className='mb-[24px] relative'>
                <Image
                  src={FergalCrotty}
                  alt='Fergal Crotty'
                  className='border-none w-[120px] max-w-full h-[120px] mb-0 rounded-full'
                />
              </div>
              <div className='flex mb-0 items-center flex-col'>
                <div
                  className={clsx(
                    'text-center mb-[8px] text-[19px] font-[700] leading-[110%] text-white',
                    'max-[768px]:text-[16px]'
                  )}
                >
                  Fergal Crotty
                </div>
                <div
                  className={clsx(
                    'text-center text-[17px] font-[400] leading-[110%] text-white mb-[24px]',
                    'max-[768px]:text-[16px]'
                  )}
                >
                  Up Digital
                </div>
                <Image
                  src={UpDigital}
                  alt='Up Digital'
                  className='w-auto h-[48px] max-w-none invert'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
